import { getFirebaseAuth } from '@/lib/firebase'

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || '/api'

export async function submitAffiliateRequest(description: string): Promise<void> {
  const auth = getFirebaseAuth()
  const token = await auth.currentUser?.getIdToken()

  const formData = new FormData()
  formData.append('Description', description)

  const response = await fetch(`${API_BASE_URL}/support`, {
    method: 'POST',
    headers: {
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
    body: formData,
  })

  if (!response.ok) {
    throw new Error(`Failed to submit request: ${response.status}`)
  }
}
